import moment from 'moment'
import 'moment-timezone'

const TZ = 'America/Argentina/Buenos_Aires'
const DATE_ONLY = /^\d{4}-\d{2}-\d{2}/

function isDateOnlyString(value) {
    return typeof value === 'string' && DATE_ONLY.test(value) && !value.includes('T')
}

/**
 * Formatea un valor a fecha/calendario en America/Argentina/Buenos_Aires.
 * - null/'' → ''
 * - string YYYY-MM-DD sin 'T' → pass-through (sin conversión TZ)
 * - ISO/instant → día calendario ART
 */
export function formatFechaArgentina(value, format = 'YYYY-MM-DD') {
    if (value == null || value === '') return ''

    if (isDateOnlyString(value)) {
        return value.slice(0, 10)
    }

    return moment(value).tz(TZ).format(format)
}

/**
 * Día calendario que eligió el operador (p. ej. Compra.fecha).
 * El API guarda YYYY-MM-DD como medianoche UTC; formatear en ART resta un día.
 */
export function formatFechaNegocio(value, format = 'YYYY-MM-DD') {
    if (value == null || value === '') return ''

    if (isDateOnlyString(value)) {
        return value.slice(0, 10)
    }

    return moment.utc(value).format(format)
}

/** Hoy calendario en ART como YYYY-MM-DD (para input type="date"). */
export function hoyArgentina() {
    return moment().tz(TZ).format('YYYY-MM-DD')
}
